import React from 'react';
import 'whatwg-fetch';
import { postEntity } from 'src/utils/entityApi';
import InputFormAssociated from '../input/inputFormAssociated';
import withAuth from 'src/hoc/withAuth';

const oriState = {
  title: null,
  text: null,
};

class ModalNotePost extends React.Component {
  constructor(props) {
    super(props);
    this.state = oriState;

    this.handleInputChange = this.handleInputChange.bind(this);
    this.handleSubmit = this.handleSubmit.bind(this);
    this.reset = this.reset.bind(this);
    this.close = this.close.bind(this);
    this.checkFormValid = this.checkFormValid.bind(this);
  }

  reset() {
    this.state = oriState;
    this.setState(oriState);
    this.componentDidMount();
  }

  handleInputChange(event) {
    const target = event.target;
    const value = target.value;
    const name = target.name;

    this.setState({
      [name]: value,
    });
  }

  componentDidMount() {}

  checkFormValid() {
    return this.state.title && this.state.title.trim() !== '' && this.state.text && this.state.text.trim() !== '';
  }

  render() {
    if (this.props.isOpen === false) return null;

    return (
      <div className='modal myModal'>
        <div className='modal-dialog modal-md'>
          <div className='modal-content'>
            <div className='modal-header'>
              <h4 className='modal-title'>Créer Note</h4>
              <button onClick={this.close} type='button' className='close' data-dismiss='modal' aria-label='Close'>
                <span aria-hidden='true'>&times;</span>
              </button>
            </div>
            <form>
              <div className='modal-body'>
                <div className='form-group'>
                  <label>Titre</label>
                  <input
                    name='title'
                    value={this.state.title}
                    onChange={this.handleInputChange}
                    type='text'
                    className='form-control'
                    placeholder='Retrouver la note plus tard'
                  />
                </div>
                <div className='form-group'>
                  <label>Texte</label>
                  <textarea
                    name='text'
                    value={this.state.text}
                    onChange={this.handleInputChange}
                    className='form-control'
                    placeholder='Contenu de la note'
                  />
                </div>
                {this.props.entityAssociated && <InputFormAssociated entityAssociated={this.props.entityAssociated} />}
              </div>
              <div className='modal-actions'>
                <button onClick={this.close} type='button' className='btn-link modal-action' data-dismiss='modal'>
                  Annuler
                </button>
                <button
                  onClick={this.handleSubmit}
                  type='button'
                  className='btn-link modal-action'
                  data-dismiss='modal'
                >
                  <strong>Créer</strong>
                </button>
              </div>
            </form>
          </div>
        </div>
      </div>
    );
  }

  handleSubmit() {
    if (this.props.onPostResult) {
      if (this.checkFormValid()) {
        let json = {
          note: {
            title: this.state.title,
            text: this.state.text,
          },
        };
        // If present -> set the Major Entity associated
        if (this.props.entityAssociated) {
          json.note['relativeTo'] = {
            [this.props.entityAssociated.type]: {
              id: this.props.entityAssociated.id,
            },
          };
        }

        this.props.onPostResult('note', postEntity(this.props.authFetch, 'note', json));
        this.close();
      } else {
        this.props.openToast(false, 'Certains champs obligatoires sont vides');
      }
    }
  }

  close() {
    this.reset();
    if (this.props.onClose) {
      this.props.onClose();
    }
  }
}

export default withAuth(ModalNotePost);
